


<template lang="jade">

	div.dialogue(
		:id="'dialogue-' + dia.id"
		@click="takefocus($event)"
	)

		div.dialogue-header
			div.dialogue-title {{ dia.title }}

			i.icon-cancel-circle.dialogue-close-button(
				:id="'dialogue-close-' + dia.id"
				@click="close"
			)

			div.activity
				div.activity-indicator

		div.dialogue-content
			component(
				:is="dia.comp"
				:dia="dia"
			)

</template>



<script>



	const $cmp = {
		name : 'app-dialogue',
		props : ['dia']
	}



	$cmp.mounted = function() {

		let $this = this
		let $window = $(window)
		let $dia = $($this.$el)

		let width = $this.dia.width
		let height = $this.dia.height
		let top = ($window.height() - height) / 2
		let left = ($window.width() - width) / 2

		if ($window.width() < 1024) {
			width = $window.width()
			height = $window.height()
			top = 0
			left = 0
		}

		let restoreWidth = $this.dia.width
		let restoreHeight = $this.dia.height

		/// Trigger this.takeFocus()
		$dia.click()

		$dia.css({
			width : width,
			height : height,
			'-webkit-transform' : 'scale(1)',
			'-moz-transform'    : 'scale(1)',
			'-ms-transform'     : 'scale(1)',
			'-o-transform'      : 'scale(1)',
			'transform'         : 'scale(1)'
		})

		$dia.css({
			top : top,
			left : left
		})

		$dia.css({
			'-webkit-transform' : 'scale(0)',
			'-moz-transform'    : 'scale(0)',
			'-ms-transform'     : 'scale(0)',
			'-o-transform'      : 'scale(0)',
			'transform'         : 'scale(0)',
			opacity : 1
		})

		let z = $this.getHighestZ() + 1
		$dia.css({ zIndex : z })

		$dia.transition({
			scale : 1,
			duration : 555,
			easing : 'snap'
		})

		if ($this.dia.draggable) {
			$dia.draggable({
				containment : 'parent',
				handle : '.dialogue-header'
			})
		}

		if ($this.dia.resize) {

			$dia.resizable({
				handles : 'all',
				minWidth : $this.dia.minWidth || 375,
				minHeight : $this.dia.minHeight || 300,
				maxWidth : $this.dia.maxWidth || 1000000000,
				maxHeight : $this.dia.maxHeight || 1000000000
			})

			$dia.on('resize', function() {
				restoreWidth = $dia.width()
				restoreHeight = $dia.height()
			})

		}

		$(window).on('resize', function(event) {

			if (event.target !== this) return

			if ($window.width() < 1024) {

				$dia.stop().transition({
					width : $(window).width(),
					height : $(window).height(),
					top : 0,
					left : 0,
					duration : 333,
					easing : 'easeOutQuad'
				})

			} else {

				$dia.stop().transition({
					width : restoreWidth,
					height : restoreHeight,
					top : ($window.height() - restoreHeight) / 2,
					left : ($window.width() - restoreWidth) / 2,
					duration : 333,
					easing : 'easeOutQuad'
				})

			}

		})

	}



	$cmp.methods = {};

	$cmp.methods.getHighestZ = function() {

		let highestZ = 0

		$('.dialogue').each(function() {
		    let zIndex = parseInt($(this).css('z-index'), 10)
		    if (zIndex > highestZ) highestZ = zIndex
		});

		return highestZ

	}

	$cmp.methods.takefocus = function($event) {

		let $this = this

		let highestZ = $this.getHighestZ()
		let thisZ = $($event.target).css('z-index')

		if (thisZ === highestZ) return

		let z = highestZ + 1
		$($this.$el).css({ zIndex : z })

		$('.dialogue-header, .dialogue-content').transition({
			opacity : 0.45,
			duration : 121,
			easing : 'easeOutQuad'
		})

		let target = $($this.$el).find('.dialogue-header, .dialogue-content')

		$(target).stop().transition({
			opacity : 1,
			duration : 333,
			easing : 'easeOutQuad'
		})

		if ($this.dia.onFocus) $this.dia.onFocus()

	}

	$cmp.methods.focusHighestZ = function() {

		let highestZ = 0
		let element = null

		$('.dialogue').each(function() {
		    let zIndex = parseInt($(this).css('zIndex'), 10)
		    if (zIndex > highestZ) {
				highestZ = zIndex
				element = $(this)
			}
		});

		$(element).click()

		return

	}

	$cmp.methods.close = function(event) {

		event.stopPropagation()

		let $this = this

		$($this.$el).transition({
			scale : 0,
			duration : 333,
			easing : 'snap'
		}, function() {
			if ($this.dia.onClose) $this.dia.onClose()
			let $dias = $this.$store.dialogues
			$this.$store.dialogues = $dias.filter(item => item.id !== $this.dia.id)
			$this.$el.remove()
			$this.focusHighestZ()
		})

	}



	export default $cmp



</script>



<style lang="stylus">

	.dialogue
		position absolute
		top 50%
		left 50%
		transform translate(-50%,-50%)
		width 300px
		height 450px
		background rgba($grey,0.98)
		box-shadow 0px 0px 5px rgba(#000000, 0.75)
		opacity 0
		pointer-events auto
		-webkit-backdrop-filter blur(5px)
		-moz-backdrop-filter blur(5px)
		-o-backdrop-filter blur(5px)
		-ms-backdrop-filter blur(5px)
		backdrop-filter blur(5px)

	.dialogue-header
		position relative
		width 100%
		height 40px
		background darkness($grey, -45%)
		opacity 0.3

		@media(max-width 1023px)
			height 60px

		.activity
			bottom 0px

	.dialogue-title
		position absolute
		height 40px
		line-height 40px
		color #FFFFFF
		padding-left 20px
		top 50%
		transform translate(0%,-50%)

	.dialogue-close-button
		position absolute
		display block
		top 50%
		transform translate(0%,-50%)
		right 8px
		opacity 0.5

	.dialogue-header .progress
		position absolute
		top 40px
		z-index 2

		@media(max-width 1023px)
			top 60px

	.dialogue-content
		position absolute
		width 100%
		top 40px
		left 0px
		right 0px
		bottom 0px
		overflow hidden
		opacity 0.3

		@media(max-width 1023px)
			top 60px

	.dialogue-buttons
		position absolute
		left 0px
		right 0px
		bottom 0px
		width 100%
		height 70px
		padding 15px
		text-align center
		background rgba($grey, 0.75)

</style>



// WEBPACK FOOTER //
// src/app-dialogue.vue